<template>
    <b-alert :show="showSeconds" :variant="variant" dismissible fade @dismissed="showSeconds=0">
        <span v-for="(msg, index) in messages" :key="index">{{ msg }}</span>
    </b-alert>
</template>

<script>
    import _ from 'lodash';

    export default {
        data() {
            return {
                variant: "info",
                messages: [],
                showSeconds: 0
            }
        },
        methods: {
            onRequestError(error) {
                if (error.response && error.response.data) {
                    if (error.response.data.errors) {
                        this.showError(_.flatMapDeep(error.response.data.errors));
                        return;
                    }
                    if (typeof error.response.data === "string") {
                        this.showError(['Unexpected Error!']);
                        console.error(error.response.data);
                        return;
                    }
                }   
                this.showError(['Unexpected Error!']);
                console.error(error);
            },
            clear() {
                this.messages = [];
                this.showSeconds = 0;
            },
            hasValidation() {
                return this.variant === "danger" && this.showSeconds > 0;
            },
            showError(messages) {
                this.setMessages(messages, "danger", 60);
            },
            setMessages(messages, variant, seconds) {
                this.variant = variant;
                this.messages = messages;
                this.showSeconds = seconds;
            }
        }
    };
</script>
